import { useContext, useEffect, useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { useForm } from "react-hook-form";
import { Grid } from "@mui/material";
import { toast } from "react-toastify";
import axios from "axios";
import { useTranslation } from "react-i18next";
import { LocaleContext } from "../../../../routing/LangRouter";

//import constants
import BASE_URL from "../../../../constants/baseUrls";

//import general components
import { BaseButton } from "../../../common/base-button/base-button";
import BaseTextField from "../../../common/base-text-field/base-text-field";
import LoginModal from "../../../common/login-modal/login-modal";
import PersonCount from "../../../common/person-count/person-count";

//import images and icons
import { ArrowLeft, ArrowRight } from "iconsax-react";

//import styles
import "./reservation-form.scss";

function ReservationForm({ tourId }) {
    //general variables
    const navigate = useNavigate();
    const [searchParams, setSearchParams] = useSearchParams();
    const { locale } = useContext(LocaleContext);
    const { t } = useTranslation();
    const [isLoading, setIsLoading] = useState(false);
    const accessToken = localStorage.getItem("accessToken");
    const ArrowIcon = locale === "en" ? ArrowRight : ArrowLeft;

    //list of person types with their details
    const [personCount, setPersonCount] = useState();
    const personList = [
        { id: 1, label: t("adult"), description: t("ageGroup1"), name: "adult", disabled: 1, validation: false },
        { id: 2, label: t("child"), description: t("ageGroup2"), name: "child", disabled: 0, validation: false },
    ];

    //initial form values
    const initialFormState = {
        count: "",
        phoneNumber: "",
    };

    //initialize form with react-hook-form
    const {
        register,
        handleSubmit,
        formState: { errors },
    } = useForm({
        defaultValues: initialFormState,
    });

    //register options
    const registerOptions = {
        phoneNumber: {
            required: `${t("phoneNumberValidation4")}`,
            maxLength: { value: 11, message: `${t("phoneNumberValidation1")}` },
            minLength: { value: 11, message: `${t("phoneNumberValidation2")}` },
            pattern: { value: /^09\d{9}$/, message: `${t("phoneNumberValidation3")}` },
        },
    };

    //handle form submission with registration data
    const handleRegistration = async data => {
        if (accessToken) {
            setIsLoading(true);
            const formData = { tour_id: tourId, mobile_phone: data.phoneNumber, adult_count: personCount.adult, child_count: personCount.child };
            try {
                const response = await axios.post(`${BASE_URL}/api/v2/itinerary/tour/request/`, formData, {
                    headers: {
                        Authorization: `Bearer ${accessToken}`,
                    },
                });
                toast.success(response.data.message);
            } catch (error) {
                toast.error(t("errorMessage"));
                if (error.response.status === 401) {
                    localStorage.clear();
                    setSearchParams({ action: "login" });
                }
            } finally {
                setIsLoading(false);
            }
        } else {
            setSearchParams({ action: "login" });
        }
    };

    //handle form submission errors
    const handleError = error => {
        console.log(error);
    };

    const navigateToMyTours = () => {
        navigate(`/${locale}/user-panel/my-tours`);
    };

    //handle modal change
    // const [isOpen, setIsOpen] = useState(false);
    // useEffect(() => {
    //     if (searchParams.get("action") === "login") setIsOpen(true);
    //     else setIsOpen(false);
    // }, [searchParams]);

    return (
        <>
            <Grid
                className="reservation-form"
                component="form"
                container
                item
                xs={12}
                rowGap={3}
                justifyContent="space-between"
                onSubmit={handleSubmit(handleRegistration, handleError)}
            >
                <Grid container item md={8} rowGap={3} columnGap={3}>
                    <Grid container item md={3}>
                        <PersonCount list={personList} handleChange={setPersonCount} />
                    </Grid>
                    <Grid container item md={3}>
                        <BaseTextField
                            dir="ltr"
                            label={t("phoneNumber")}
                            name="phoneNumber"
                            type="number"
                            radius="10px"
                            register={{ ...register("phoneNumber", registerOptions.phoneNumber) }}
                            error={errors?.phoneNumber?.message}
                        />
                    </Grid>
                </Grid>

                <Grid container item md={2} rowGap={1}>
                    <BaseButton text={t("reservationRequest")} color="primary" size="large" radius="radius-10" loading={isLoading} />
                    <Grid
                        className="reservation-form__request-list"
                        component="span"
                        container
                        item
                        xs={12}
                        columnGap={1}
                        justifyContent={{ xs: "center", md: "flex-end" }}
                        alignItems="center"
                        onClick={navigateToMyTours}
                    >
                        {t("requestList")} <ArrowIcon color="var(--secondary-color)" />
                    </Grid>
                </Grid>
            </Grid>
            {/* <LoginModal open={isOpen} setOpen={setIsOpen} /> */}
        </>
    );
}

export default ReservationForm;
